module.exports = __webpack_public_path__ + "img/wz-4-3.2e54b7da.png";